import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("gf_token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("gf_user");
    if (stored) {
      try { setUser(JSON.parse(stored)); } catch (_) {}
    }
    if (token) {
      api.get("/auth/me")
        .then((r) => {
          setUser(r.data);
          localStorage.setItem("gf_user", JSON.stringify(r.data));
        })
        .catch(() => logout())
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = (token, user) => {
    localStorage.setItem("gf_token", token);
    localStorage.setItem("gf_user", JSON.stringify(user));
    setToken(token);
    setUser(user);
  };

  const refreshUser = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      localStorage.setItem("gf_user", JSON.stringify(r.data));
    } catch (_) {}
  };

  const logout = () => {
    localStorage.removeItem("gf_token");
    localStorage.removeItem("gf_user");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, loading, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
